/**
 * Node-global polyfills for y-webrtc's transitive dependency `simple-peer`,
 * which references `global` / `process` / `Buffer`. webpack 5 (react-scripts 5)
 * no longer injects these automatically, so without this the WebRTC provider
 * throws `global is not defined` at module-init time.
 *
 * Imported FIRST in index.tsx (before the App module graph, which pulls in
 * y-webrtc) so the globals exist before that code evaluates.
 */
import { Buffer } from "buffer";

const g = window as unknown as Record<string, unknown>;
if (!g.global) g.global = window;
if (!g.Buffer) g.Buffer = Buffer;
if (!g.process) g.process = { env: {} };

export {};
